import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    id: Number,
    status: String,
    viewUrl: String,
    generateUrl: String,

    createdText: String,
    generatingText: String,
    generatedText: String,

    isActive: Boolean
  }

  isActiveValueChanged(value) {
    if (value) {
      this.element.classList.add('active');
    } else {
      this.element.classList.remove('active');
    }
  }

  statusValueChanged(value, previousValue) {
    if (value === previousValue){
      return
    }

    const link = this.element.tagName === 'A' ? this.element : this.element.querySelector('a');
    if (value === 'created') {
      link.setAttribute('href', this.generateUrlValue);
      link.setAttribute('data-turbo-method', 'post');
    }
    else {
      link.setAttribute('href', this.viewUrlValue);
      link.setAttribute('data-turbo-method', 'get');
    }

    // Show status-depended elements (e.g. different text, spinners or magic wand)
    this.element.querySelectorAll('[data-module-link-status-indicator]').forEach((element) => {
      if (element.getAttribute('data-module-link-status-indicator') === value) {
        element.classList.remove('d-none');
      } else {
        element.classList.add('d-none');
      }
    });
  }
}
